import { render, staticRenderFns } from "./AuthorizedTableCell.vue?vue&type=template&id=53bb564a&scoped=true"
import script from "./AuthorizedTableCell.vue?vue&type=script&lang=js"
export * from "./AuthorizedTableCell.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedTableCell.vue?vue&type=style&index=0&id=53bb564a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb564a",
  null
  
)

export default component.exports